import { Modal, ModalContent, ModalActions } from "components/Modal"
import { Button } from "components/Button"
import { useTranslator } from "components/Translator"

export function ExternalUserModal({ isOpen, onRequestClose }) {
  const translator = useTranslator()
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      title={translator.trans(
        "AdvertParticipants.externalParticipantModal.title",
        null,
        "components",
      )}
    >
      <ModalContent>
        {translator.trans(
          "AdvertParticipants.externalParticipantModal.description",
          null,
          "components",
        )}
      </ModalContent>
      <ModalActions>
        <div className="w-full justify-center flex">
          <Button
            color="danger"
            type="button"
            href={translator.trans(
              "AdvertParticipants.externalParticipantModal.buttonUrl",
              null,
              "components",
            )}
            external
          >
            {translator.trans(
              "AdvertParticipants.externalParticipantModal.buttonTitle",
              null,
              "components",
            )}
          </Button>
        </div>
      </ModalActions>
    </Modal>
  )
}
